import styled from "styled-components";

export const TopLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  margin-left: 6px;
  font-family: sans-serif;
`;
export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2vh;
  height: 100%;
  width: 100%;
  .lbl{
    font-size: 13px;
    font-weight: 400;
    margin-left: 6px;
    font-family: sans-serif;
  }
`;
